import styled from 'styled-components'
import Ex2 from "../imagens/foto18obra.jpg"

export const Main = styled.main`

`
export const SectionInicial = styled.section`
background-image: url(${Ex2});
background-position: center;
display: flex;
justify-content: flex-start;
align-items: center;
`
export const DivInicial = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
gap: 25px;
height: 60vh;
width: 42%;
background-color: rgba(0,0,0,0.7);
color: white;
h1 {
    font-size: 1.8rem;
    width: 70%;
    text-align: center;
}
a {
    text-decoration: none;
    color: black;
}
button {
    transition: 0.1s;
    font-size: 1.3rem;
    border: none;
    background-color: #FFEB3B;
    cursor: pointer;
    width: 10vw;
    border-radius: 5px;
}
button:hover {
    transition: 0.1s;
    background-color: #838280;
}
@media (min-width: 201px) and (max-width: 500px) {
    width: 50%;
    height: 45vh;
    h1 {
        font-size: 1.2rem;
        width: 100%;
    }
    button {
        width: 80%;
        font-size: 1.1rem;
        margin-left: 0.5rem;
    }
}
@media (min-width: 501px) and (max-width: 900px) {
    width: 45%;
    height: 50vh;
    h1 {
        width: 75%;
    } 
    button {
        width: 80%;
    }
}
`
export const SectionServicos = styled.section`
padding-top: 1rem;
background-color: #eaeaea;
display: flex;
justify-content: center;
align-items: center;
`
export const DivText = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
justify-content: space-evenly;
height: 90vh;
button {
    transition: 0.1s;
    background-color: #838280;
    border: none;
    font-size: 1.2rem;
    width: 11vw;
    height: 5vh;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 1.5rem;
}
button:hover {
    background-color: black;
    transition: 0.1s;
    color: white;
}
a {
    text-decoration: none;
    color: inherit;
    align-self: center;
}
@media (min-width: 201px) and (max-width: 500px) {
    button {
        width: 70%;
        height: 6vh;
        margin-left: 0.5rem;
    }
}
@media (min-width: 501px) and (max-width: 900px) {
    height: 75vh;
    button {
        font-size: 1.4rem;
        width: 50%;
        height: 5vh;
        margin-left: 16rem;
    }
    align-items: flex-start;
}
`
export const DivTextTitle = styled.div`
display: flex;
flex-direction: column;
justify-content: space-evenly;
h2 {
    font-size: 1.9rem;
    font-weight: 800;
}
p {
    font-size: 1.2rem;
}
margin-bottom: 0.5rem;
height: 15vh;
margin-left: 1rem;
`
export const DivTextServices = styled.div`
margin-left: 1rem;
`
export const PTextServices = styled.p`
font-size: 1.1rem;
margin-left: 3rem;
@media (min-width: 501px) and (max-width: 900px) {
    font-size: 1.3rem;
}
`
export const DivDesc = styled.div`
p {
    font-size: 1.3rem;
    font-weight: 600;
}
display: flex;
align-items: center;
gap: 10px;
@media (min-width: 501px) and (max-width: 900px) {
    svg {
        width: 40px;
        height: 40px;
    }
    p {
        font-size: 1.5rem;
    }
}
`
export const DivImg = styled.div`
img {
    width: 75%;
    border-radius: 5px;
    box-shadow: 0px 2px 2px 0px;
}
display: flex;
justify-content: center;
align-items: center;
@media (min-width: 201px) and (max-width: 500px) {
    display: none;
}
@media (min-width: 501px) and (max-width: 900px) {
    display: none;
}
`
export const SectionPortfolio = styled.section`

`

